/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';

export const validate = (feature: BaseFeature) : Array<ValidationMessage> => {
    const errors: Array<ValidationMessage> = [];
    const PATH = feature.getSettingValue('PATH');
    const parts = feature.getSettingValue('FILE').split('\n');
    const fileName = parts[0];
    if (fileName !== `${PATH}.html`) {
        const contents = `
<?
include "global.tbh"
sys.debugprint("http endpoint requested ${PATH}")
dim payload as string=sock.httprqstring
http_endpoint_requested_${PATH}(payload, "")
?>
`;
        let b64Contents = '';
        if (typeof btoa !== 'undefined') {
            b64Contents = btoa(contents);
        } else {
            b64Contents = Buffer.from(contents).toString('base64');
        }

        const message: ValidationMessage = {
            messageType: ValidationMessageType.UPDATE,
            message: 'http endpoint updated',
            settingId: 'FILE',
            featureId: feature.getID(),
            data: `${PATH}.html\n${b64Contents}`,
        };
        errors.push(message);
    }

    return errors;
};


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];
    const PATH = feature.getSettingValue('PATH');
    if (PATH === '') {
        return blocks;
    }

    blocks.push({
        location: 'callback_http_server_endpoint_called',
        blockType: BlockType.CODE,
        id: `http_endpoint_requested_${PATH}_integration`,
        template: `
if server.request_file_name="${PATH}.html" OR server.request_file_name="${PATH}" then
    callback_http_server_endpoint_called=true
    dim data as string=server.request_path
    dim query as string=""
    dim index as byte=instr(1,server.request_path,"?",1)
    if index>0 then
        query=mid(server.request_path,index+1,255)
    end if
    if server.request_method="GET" then
        data=query
    else
        data=server.request_value_buffer
    end if
    http_endpoint_requested_${PATH}(data, query)
end if
        `,
    });

    blocks.push({
        location: 'GLOBAL_DECLARATIONS',
        blockType: BlockType.CODE,
        id: `declare_http_endpoint_requested_${PATH}`,
        template: `declare sub http_endpoint_requested_${PATH}(byref data as string, byref query as string)`,
    });

    blocks.push({
        location: 'DEVICE_TBS',
        blockType: BlockType.CODE,
        id: `http_endpoint_requested_${PATH}`,
        template: `
sub http_endpoint_requested_${PATH}(byref data as string, byref query as string)
dim handle_response as boolean=false
'****HTTP_ENDPOINT_REQUESTED_HANDLE_CUSTOM_${PATH}****'
if handle_response then
    '****HTTP_ENDPOINT_REQUESTED_${PATH}****'
else
    http_server_response_status(200)
    '****HTTP_ENDPOINT_REQUESTED_${PATH}_HEADERS****'
    http_server_response_header_end()
end if


end sub`,
    });
    return blocks;
};
